import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  customerId: string;
}
interface IConnectGustoResponse {
  companyName: string;
  externalId: string;
  displayName: string;
}

interface IPayrollLinkReq {
  code: string;
  state: string;
}

export const useConnectGusto = ({ customerId }: IProps, onSuccess: (response: IConnectGustoResponse) => void, onError: (error: any) => void) => useMutation(
  'connectGusto',
  async ({ code, state }: IPayrollLinkReq) => {
    const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/payroll/link`, { code, state });
    return data;
  },
  {
    onSuccess: (response: IConnectGustoResponse) => {
      onSuccess(response);
    },
    onError: (error: any) => {
      onError(error);
    },
  },
);
